import React from "react";
import { Routes, Route } from "react-router-dom";
import Login0 from "../Pages/AuthPages/Login";
import ForgotPassword from "../Pages/AuthPages/ForgotPassword";
import LoginWithId from "../Pages/AuthPages/Login/LoginWithId";
// import SignUp from "../Pages/AuthPages/SignUp";
import UnAuthorizedPaymentReceipt from './../Pages/AuthPages/Login/UnAuthorizedPaymentReceipt';
import _2FAPassword from "../Pages/AuthPages/ForgotPassword/login2fA";

const AuthRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<SignUp />} /> */}
      <Route path="/" element={<Login0 />} />
      <Route path="/login/:id" element={<LoginWithId />} />
      <Route path="/payment/:id" element={<UnAuthorizedPaymentReceipt />} />
      <Route path="/reset-password/2FA" element={<_2FAPassword />} />
      <Route path="/reset-password" element={<ForgotPassword />} />
    </Routes>
  );
};

export default AuthRoutes;
